export enum ActivePaymentsTab {
  OVERVIEW = 'overview',
  DETAILS = 'details',
  ACCEPTANCE = 'Acceptance',
  REVIEW = 'Review',
}

export enum EmployeesTab {
  ALL = 'all',
  REVIEW = 'review',
  ACCEPTANCE = 'acceptance',
}
